<p>
    <mat-toolbar>
        <button mat-icon-button class="example-icon" [matMenuTriggerFor]="mainMenu">
            <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #mainMenu="matMenu">
            <button mat-menu-item routerLink="web-editor.html/app-editor">
                <mat-icon>editor</mat-icon>
                <span>Editor</span>
            </button>
            <button mat-menu-item routerLink="web-editor.html/json-editor">
                <mat-icon>code</mat-icon>
                <span>Json source editor</span>
            </button>
            <button mat-menu-item routerLink="web-editor.html/app-renderer">
                <mat-icon>preview</mat-icon>
                <span>Preview</span>
            </button>
            <button mat-menu-item routerLink="web-editor.html/data-history">
                <mat-icon>history</mat-icon>
                <span>Data History</span>
            </button>
            <button mat-menu-item routerLink="web-editor.html/samples">
                <mat-icon>content_copy</mat-icon>
                <span>Samples</span>
            </button>
        </mat-menu>

        <span>Dynamic WYSIWYG Web Component Editor</span>

    </mat-toolbar>
</p>
<router-outlet [routerLink]="['web-editor.html']"></router-outlet>
